/* NgRx */
import {createAction, props} from '@ngrx/store';
import {Filter} from '../../../../models/filter';
import {ClinicsList} from '../../../../models/clinics-list';
import {GroupsList} from '../../../../models/groups-list';
import {
  ParticipantsAndCaregiversList
} from '../../../../models/participants-and-caregivers-list';
import {
  ParticipantsWeightList
} from '../../../../models/participants-weight-list';
import {
  ParticipantsBehaviourList
} from '../../../../models/participants-behaviour-list';
import {
  FetchMetricOptionListModel
} from '../model/fetch-metric-option-list.model';
import {
  MetricOptionListModel
} from '../../../../models/metric-option-list.model';
import {AddMetricOptionModel} from '../model/add-metric-option.model';
import {UpdateMetricOptionModel} from '../model/update-metric-option.model';
import {FetchClinicFilterModel} from "../model/fetch-clinic-filter.model";
import {FetchClinicListModel} from '../model/fetch-clinic-list.model';
import {FetchGroupFilterModel} from '../model/fetch-group-filter.model';
import {
  FetchParticipantsAndCaregiversListModel
} from '../model/fetch-participants-and-caregivers-list.model';
import {
  FetchParticipantsWeightListModel
} from '../model/fetch-participants-weight-list.model';


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[clients list] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH GROUPS LIST ***********/
const FETCH_CLIENTS_LIST_REQUEST = '[clients list] fetch clients list request';
export const FetchClientsListRequest = createAction(FETCH_CLIENTS_LIST_REQUEST);

const FETCH_CLIENTS_LIST_SUCCESS = '[clients list] fetch clients list success';
export const FetchClientsListSuccess = createAction(FETCH_CLIENTS_LIST_SUCCESS, props<{
  clientsList: any[],
  message: string
}>());

const FETCH_CLIENTS_LIST_FAILURE = '[clients list] fetch clients list failure';
export const FetchClientsListFailure = createAction(FETCH_CLIENTS_LIST_FAILURE);

/*********** FETCH DASHBOARD FILTER **************/
const FETCH_DASHBOARD_FILTER_REQUEST = '[clients list] fetch dashboard filter requested';
export const FetchDashboardFilterRequest = createAction(FETCH_DASHBOARD_FILTER_REQUEST);

const FETCH_DASHBOARD_FILTER_SUCCESS = '[clients list] fetch dashboard filter successful';
export const FetchDashboardFilterSuccess = createAction(FETCH_DASHBOARD_FILTER_SUCCESS, props<{
  dashboardFilter: Filter,
  message: string
}>());

const FETCH_DASHBOARD_FILTER_FAILURE = '[clients list] fetch dashboard filter failure';
export const FetchDashboardFilterFailure = createAction(FETCH_DASHBOARD_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH CLINIC FILTER **************/
const FETCH_CLINIC_FILTER_REQUEST = '[clients list] fetch clinic filter requested';
export const FetchClinicFilterRequest = createAction(FETCH_CLINIC_FILTER_REQUEST, props<{
  payload?: FetchClinicFilterModel['request']
}>());

const FETCH_CLINIC_FILTER_SUCCESS = '[clients list] fetch clinic filter successful';
export const FetchClinicFilterSuccess = createAction(FETCH_CLINIC_FILTER_SUCCESS, props<{
  clinicFilter: Filter,
  message: string
}>());

const FETCH_CLINIC_FILTER_FAILURE = '[clients list] fetch clinic filter failure';
export const FetchClinicFilterFailure = createAction(FETCH_CLINIC_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH STATUS FILTER **************/
const FETCH_STATUS_FILTER_REQUEST = '[clients list] fetch status filter requested';
export const FetchStatusFilterRequest = createAction(FETCH_STATUS_FILTER_REQUEST);

const FETCH_STATUS_FILTER_SUCCESS = '[clients list] fetch status filter successful';
export const FetchStatusFilterSuccess = createAction(FETCH_STATUS_FILTER_SUCCESS, props<{
  statusFilter: Filter,
  message: string
}>());

const FETCH_STATUS_FILTER_FAILURE = '[clients list] fetch status filter failure';
export const FetchStatusFilterFailure = createAction(FETCH_STATUS_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH CLINIC LIST ***********/
const FETCH_CLINIC_LIST_REQUEST = '[clients list] fetch clinic list request';
export const FetchClinicListRequest = createAction(FETCH_CLINIC_LIST_REQUEST, props<{ payload: FetchClinicListModel['request'] }>());

const FETCH_CLINIC_LIST_SUCCESS = '[clients list] fetch clinic list success';
export const FetchClinicListSuccess = createAction(FETCH_CLINIC_LIST_SUCCESS, props<{
  clinicsList: ClinicsList,
  message: string
}>());

const FETCH_CLINIC_LIST_FAILURE = '[clients list] fetch clinic list failure';
export const FetchClinicListFailure = createAction(FETCH_CLINIC_LIST_FAILURE);

/******** FETCH GROUPS LIST ***********/
const FETCH_GROUPS_LIST_REQUEST = '[clients list] fetch groups list request';
export const FetchGroupsListRequest = createAction(FETCH_GROUPS_LIST_REQUEST, props<any>());

const FETCH_GROUPS_LIST_SUCCESS = '[clients list] fetch groups list success';
export const FetchGroupsListSuccess = createAction(FETCH_GROUPS_LIST_SUCCESS, props<{
  groupsList: GroupsList,
  message: string
}>());

const FETCH_GROUPS_LIST_FAILURE = '[clients list] fetch groups list failure';
export const FetchGroupsListFailure = createAction(FETCH_GROUPS_LIST_FAILURE);

/******** FETCH PARTICIPANT AND CAREGIVERS LIST ***********/
const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST = '[clients list] fetch participants and caregivers list request';
export const FetchParticipantsAndCaregiversListRequest = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST, props<{
  payload: FetchParticipantsAndCaregiversListModel['request']
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS = '[clients list] fetch participants and caregivers list success';
export const FetchParticipantsAndCaregiversListSuccess = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS, props<{
  participantsAndCaregiversList: ParticipantsAndCaregiversList,
  message: string
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE = '[clients list] fetch participants and caregivers list failure';
export const FetchParticipantsAndCaregiversListFailure = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE);

/******** FETCH PARTICIPANT WEIGHT LIST ***********/
const FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST = '[clients list] fetch participants weight list request';
export const FetchParticipantsWeightListRequest = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST, props<{ payload: FetchParticipantsWeightListModel['request'] }>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS = '[clients list] fetch participants weight list success';
export const FetchParticipantsWeightListSuccess = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS, props<{
  participantsWeightList: ParticipantsWeightList,
  message: string
}>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE = '[clients list] fetch participants weight list failure';
export const FetchParticipantsWeightListFailure = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE);

/******** FETCH PARTICIPANT BEHAVIOUR LIST ***********/
const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST = '[clients list] fetch participants behaviour list request';
export const FetchParticipantsBehaviourListRequest = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST, props<any>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS = '[clients list] fetch participants behaviour list success';
export const FetchParticipantsBehaviourListSuccess = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS, props<{
  participantsBehaviourList: ParticipantsBehaviourList,
  message: string
}>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE = '[clients list] fetch participants behaviour list failure';
export const FetchParticipantsBehaviourListFailure = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE);

/******** FETCH METRIC OPTION LIST ***********/
const FETCH_METRIC_OPTION_LIST_REQUEST = '[clients list] fetch metric option list request';
export const FetchMetricOptionListRequest = createAction(FETCH_METRIC_OPTION_LIST_REQUEST, props<{
  payload?: FetchMetricOptionListModel['request']
}>());

const FETCH_METRIC_OPTION_LIST_SUCCESS = '[clients list] fetch metric option list success';
export const FetchMetricOptionListSuccess = createAction(FETCH_METRIC_OPTION_LIST_SUCCESS, props<{
  measurementInformationList: MetricOptionListModel,
  message: string
}>());

const FETCH_METRIC_OPTION_LIST_FAILURE = '[clients list] fetch metric option list failure';
export const FetchMetricOptionListFailure = createAction(FETCH_METRIC_OPTION_LIST_FAILURE);

/*********** FETCH MEASUREMENT FILTER **************/
const FETCH_MEASUREMENT_FILTER_REQUEST = '[clients list] fetch measurement filter requested';
export const FetchMeasurementFilterRequest = createAction(FETCH_MEASUREMENT_FILTER_REQUEST);

const FETCH_MEASUREMENT_FILTER_SUCCESS = '[clients list] fetch measurement filter successful';
export const FetchMeasurementFilterSuccess = createAction(FETCH_MEASUREMENT_FILTER_SUCCESS, props<{
  measurementFilter: Filter,
  message: string
}>());

const FETCH_MEASUREMENT_FILTER_FAILURE = '[clients list] fetch measurement filter failure';
export const FetchMeasurementFilterFailure = createAction(FETCH_MEASUREMENT_FILTER_FAILURE, props<{
  message: string
}>());

/*********** SAVE CONFIG ID **************/
const SAVE_CONFIG_ID = '[clients list] save config id';
export const SaveConfigId = createAction(SAVE_CONFIG_ID, props<{ configId: number }>());

/******** ADD METRIC OPTION ***********/
const ADD_METRIC_OPTION_REQUEST = '[clients list] add metric option request';
export const AddMetricOptionRequest = createAction(ADD_METRIC_OPTION_REQUEST, props<{
  payload: AddMetricOptionModel['unprocessedRequest']
}>());

const ADD_METRIC_OPTION_SUCCESS = '[clients list] add metric option success';
export const AddMetricOptionSuccess = createAction(ADD_METRIC_OPTION_SUCCESS, props<{ message: string }>());

const ADD_METRIC_OPTION_FAILURE = '[clients list] add metric option failure';
export const AddMetricOptionFailure = createAction(ADD_METRIC_OPTION_FAILURE);

/******** UPDATE METRIC OPTION ***********/
const UPDATE_METRIC_OPTION_REQUEST = '[clients list] update metric option request';
export const UpdateMetricOptionRequest = createAction(UPDATE_METRIC_OPTION_REQUEST, props<{
  payload: UpdateMetricOptionModel['unprocessedRequest']
}>());

const UPDATE_METRIC_OPTION_SUCCESS = '[clients list] update metric option success';
export const UpdateMetricOptionSuccess = createAction(UPDATE_METRIC_OPTION_SUCCESS, props<{ message: string }>());

const UPDATE_METRIC_OPTION_FAILURE = '[clients list] update metric option failure';
export const UpdateMetricOptionFailure = createAction(UPDATE_METRIC_OPTION_FAILURE);

/*********** FETCH GROUP TYPE FILTER **************/
const FETCH_GROUP_TYPE_FILTER_REQUEST = '[clients list] fetch group type filter requested';
export const FetchGroupTypeFilterRequest = createAction(FETCH_GROUP_TYPE_FILTER_REQUEST);

const FETCH_GROUP_TYPE_FILTER_SUCCESS = '[clients list] fetch group type filter successful';
export const FetchGroupTypeFilterSuccess = createAction(FETCH_GROUP_TYPE_FILTER_SUCCESS, props<{
  groupTypeFilter: Filter,
  message: string
}>());

const FETCH_GROUP_TYPE_FILTER_FAILURE = '[clients list] fetch group type filter failure';
export const FetchGroupTypeFilterFailure = createAction(FETCH_GROUP_TYPE_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH ORG TYPE FILTER LIST ***********/
const FETCH_ORG_TYPE_FILTER_LIST_REQUEST = '[clients list] fetch org type filter list request';
export const FetchOrgTypeFilterListRequest = createAction(FETCH_ORG_TYPE_FILTER_LIST_REQUEST);

const FETCH_ORG_TYPE_FILTER_LIST_SUCCESS = '[clients list] fetch org type filter list success';
export const FetchOrgTypeFilterListSuccess = createAction(FETCH_ORG_TYPE_FILTER_LIST_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_ORG_TYPE_FILTER_LIST_FAILURE = '[clients list] fetch org type filter list failure';
export const FetchOrgTypeFilterListFailure = createAction(FETCH_ORG_TYPE_FILTER_LIST_FAILURE);

/******** FETCH CLINIC STATUS FILTER LIST ***********/
const FETCH_CLINIC_STATUS_FILTER_LIST_REQUEST = '[clients list] fetch clinic status filter list request';
export const FetchClinicStatusFilterListRequest = createAction(FETCH_CLINIC_STATUS_FILTER_LIST_REQUEST);

const FETCH_CLINIC_STATUS_FILTER_LIST_SUCCESS = '[clients list] fetch clinic status filter list success';
export const FetchClinicStatusFilterListSuccess = createAction(FETCH_CLINIC_STATUS_FILTER_LIST_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_CLINIC_STATUS_FILTER_LIST_FAILURE = '[clients list] fetch clinic status filter list failure';
export const FetchClinicStatusFilterListFailure = createAction(FETCH_CLINIC_STATUS_FILTER_LIST_FAILURE);

/*********** FETCH GROUP LIST FILTER **************/
const FETCH_GROUP_LIST_FILTER_REQUEST = '[clients list] fetch group list filter requested';
export const FetchGroupListFilterRequest = createAction(FETCH_GROUP_LIST_FILTER_REQUEST, props<{
  payload: FetchGroupFilterModel['request']
}>());

const FETCH_GROUP_LIST_FILTER_SUCCESS = '[clients list] fetch group list filter successful';
export const FetchGroupListFilterSuccess = createAction(FETCH_GROUP_LIST_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_GROUP_LIST_FILTER_FAILURE = '[clients list] fetch group list filter failure';
export const FetchGroupListFilterFailure = createAction(FETCH_GROUP_LIST_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH USER STATUS FILTER LIST **************/
const FETCH_USER_STATUS_LIST_FILTER_REQUEST = '[clients list] fetch user status lists filter requested';
export const FetchUserStatusListFilterRequest = createAction(FETCH_USER_STATUS_LIST_FILTER_REQUEST);

const FETCH_USER_STATUS_LIST_FILTER_SUCCESS = '[clients list] fetch user status lists filter successful';
export const FetchUserStatusListFilterSuccess = createAction(FETCH_USER_STATUS_LIST_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_USER_STATUS_LIST_FILTER_FAILURE = '[clients list] fetch user status lists filter failure';
export const FetchUserStatusListFilterFailure = createAction(FETCH_USER_STATUS_LIST_FILTER_FAILURE, props<{
  message: string
}>());
